import JSONPointerEvaluateError from "./JSONPointerEvaluateError.mjs";
class JSONPointerIndexError extends JSONPointerEvaluateError {}
export default JSONPointerIndexError;